import {CommonModule} from '@angular/common';
import {MaterialModule} from '../shared/material.module';
import {NgModule} from '@angular/core';
import {StatutePageComponent} from './statute-page.component';
import {StatutePageRoutingModule} from './statute-page-routing.module';
import {TitleModule} from '../layout/components/title/title.module';

@NgModule({
  declarations: [StatutePageComponent],
  imports: [
    CommonModule,
    MaterialModule,
    StatutePageRoutingModule,
    TitleModule
  ]
})

export class StatutePageModule {
}
